<template>
  <div class="list-group action-list-group">
    <a v-for="item in items" v-bind:href="item.link" class="list-group-item">
      <i v-bind:class="`mdi mdi-${ item.icon } list-btn btn-${ item.type }`"></i> {{ item.name }}
    </a>
  </div>
</template>

<script>
export default {
  name: "ActionGroupListComponent",
  props: {
    items: {
      type: Array,
      required: true,
      validator(items) {
        for (let index in items) {
          let item = items[index];
          if (!item.link || !item.icon || !item.type || !item.name) {
            return false;
          }

          let types = ['primary', 'default', 'info', 'success', 'warning', 'danger'];

          if (types.indexOf(item.type) === -1) {
            return false;
          }

          return true
        }
      }
    }
  },
}
</script>

<style scoped>

</style>
